<div class="pi-wrapper">
  <div class="white-background"></div>
  <div class="white-background small"></div>
  <div class="pi-scroll-container">
    @if (!sovData()) {
      <div class="loading">loading...</div>
    } @else {
      <div class="pi-sovs">
        <div class="sov-line header">
          <div class="sticky col-span-2">SOV description</div>
          <div>Prime SOV</div>
          <div>Previous</div>
          <div>Current</div>
          <div>Retainage</div>
          <div>Invoice</div>
          <div>Completed</div>
          <div>To Complete</div>
          <div>Retainage Balance</div>
          <div>Release</div>
        </div>
        @for (sov of sovData(); track sov.sov_id; let index = $index) {
          <div class="sov-line">
            <div class="index-box sticky">{{ index + 1 }}</div>
            <div class="fixed-input sticky">{{ sov.name }}</div>
            <div class="fixed-input">{{ sov.value | money: 'positiveComa' }}</div>
            <div class="fixed-input">{{ sov.previous_invoice_amount | money: 'positiveComa' }}</div>

            <app-floating-input
              [disabled]="!canBeEdited()"
              type="money"
              [ngModel]="sov.current_amount"
              (ngModelChange)="onCurrentValueChange($event, index)"
              [name]="'current_amount_' + sov.sov_id"
              [verticalSpacing]="false"
            >
            </app-floating-input>

            <div class="fixed-input" [ngClass]="{ negative: sov.current_retainage < 0 }">
              <!--retainage-->
              {{ sov.current_retainage | money: 'positiveComa' }}
            </div>
            <div class="fixed-input highlighted" [ngClass]="{ negative: sov.invoice_value < 0 }">
              <!--invoice-->
              {{ sov.invoice_value | money: 'positiveComa' }}
            </div>
            <div class="fixed-input with-additional-info" [ngClass]="{ negative: sov.completed < 0 }">
              <!--completed-->
              <div class="value">{{ sov.completed | money: 'positiveComa' }}</div>
              <div class="additional-info">{{ (sov.completed / (sov.value || 1)) * 100 | number: '1.0-0' }}%</div>
            </div>
            <div class="fixed-input" [ngClass]="{ negative: sov.to_complete < 0 }">
              <!--to complete-->
              {{ sov.to_complete | money: 'positiveComa' }}
            </div>
            <div class="fixed-input" [ngClass]="{ negative: sov.retainage_balance < 0 }">
              <!--remaining balance-->
              {{ sov.retainage_balance | money: 'positiveComa' }}
            </div>
            <div>
              <app-dropdown
                [disabled]="!canBeEdited()"
                [ngModel]="sov.retainage_release_percent"
                (ngModelChange)="onRetainageRateChange($event, index)"
                [name]="'set_retainage_rate_' + index"
                [options]="retainageRates"
                [showContentAsPlaceholder]="true"
                class="mt-0 mb-0"
              >
                <ng-template #selectedContent let-option>
                  <div class="dropdown-item">
                    @if (sov.retainage_release_percent >= 1000 || sov.retainage_release_percent <= -1000) {
                      {{ (sov.retainage_release_percent / 1000 | number: '1.0-1') + 'K %' }}
                    } @else {
                      {{ (sov.retainage_release_percent | number: '1.0-1') + ' %' }}
                    }
                  </div>
                </ng-template>
              </app-dropdown>
            </div>
          </div>
        }
      </div>
      <div class="pi-totals">
        <div class="sov-line z-10 relative border-top"></div>
        <div class="sov-line">
          <div class="index-box sticky"></div>
          <div class="fixed-input sticky">SOV Total</div>
          <div class="fixed-input">{{ totals().value | money: 'positiveComa' }}</div>
          <div class="fixed-input">{{ totals().previous_invoice_amount | money: 'positiveComa' }}</div>
          <div class="fixed-input">{{ totals().current_amount | money: 'positiveComa' }}</div>
          <div class="fixed-input">{{ totals().current_retainage | money: 'positiveComa' }}</div>
          <div class="fixed-input highlighted">{{ totals().invoice_value | money: 'positiveComa' }}</div>
          <div class="fixed-input with-additional-info" [ngClass]="{ negative: totals().completed < 0 }">
            <div class="value">{{ totals().completed | money: 'positiveComa' }}</div>
            <div class="additional-info">
              {{ (totals().completed / (totals().value || 1)) * 100 | number: '1.0-0' }}%
            </div>
          </div>
          <div class="fixed-input">{{ totals().to_complete | money: 'positiveComa' }}</div>
          <div class="fixed-input">{{ totals().retainage_balance | money: 'positiveComa' }}</div>
          <div class="fixed-input"></div>
        </div>
        <div class="sov-line">
          <div class="index-box sticky"></div>
          <div class="fixed-input sticky">Retainage Release</div>
          <div class="fixed-input"></div>
          <div class="fixed-input"></div>
          <div class="fixed-input"></div>
          <div class="fixed-input"></div>
          <div class="fixed-input highlighted">{{ totals().retainage_release | money: 'positiveComa' }}</div>
          <div class="fixed-input"></div>
          <div class="fixed-input"></div>
          <div class="fixed-input"></div>
          <div>
            <app-dropdown
              class="mt-0 mb-0"
              [disabled]="!canBeEdited()"
              [ngModel]="totalRetainageRelease"
              (ngModelChange)="onTotalRetainageChange($event)"
              [name]="'set_retainage_rate_total'"
              [options]="retainageRates"
            >
              <ng-template #selectedContent let-option>
                <div class="dropdown-item">
                  {{ (totals().retainage_release_percent | number: '1.0-1') + ' %' }}
                </div>
              </ng-template>
            </app-dropdown>
          </div>
        </div>
        <div class="sov-line">
          <div class="index-box sticky"></div>
          <div class="fixed-input sticky">Total Amount Due</div>
          <div class="fixed-input"></div>
          <div class="fixed-input"></div>
          <div class="fixed-input"></div>
          <div class="fixed-input"></div>
          <div class="fixed-input highlighted">
            {{ totals().invoice_value + totals().retainage_release | money: 'positiveComa' }}
          </div>
          <div class="fixed-input"></div>
          <div class="fixed-input"></div>
          <div class="fixed-input"></div>
          <div class="fixed-input"></div>
        </div>
      </div>
    }
  </div>
</div>
